import { Status } from '@/models/status'
import { PricingApi, ServiceType, ShipmentApi } from '@/models/interfaces/service'

// Globals
export const GLOBALS = {
  NAV_WIDTH: 230,
  NAV_BREAKPOINTS: {
    MOBILE: 521
  }
}

export const STOCK_ITEM_ARTICLE_NUMBER_BASE = "1000000"


// @Settings @LocalStorage (/ Cookies)
export const CBOOL_TRUE = 't'
export const CBOOL_FALSE = 'f'
export const SETTING_CNAME_BASE = '__directr--setting_'
export const USER_SETTINGS_CNAMES = {
  hideOperationalDashboard: `${SETTING_CNAME_BASE}defaults__hide-operational-dashboard`,
  defaultTab: `${SETTING_CNAME_BASE}defaults__order-tab`,
  darkModeEnabled: `${SETTING_CNAME_BASE}defaults__dark-mode-enabled`,
  hideResolved: `${SETTING_CNAME_BASE}defaults__hide-resolved`,
  newFirst: `${SETTING_CNAME_BASE}defaults__new-orders-first`,
  orderViewMode: `${SETTING_CNAME_BASE}defaults__order-view-mode`,
  orderAutoAdvance: `${SETTING_CNAME_BASE}defaults__order-auto-advance`,
  showNewAsPickable: `${SETTING_CNAME_BASE}defaults__order-new-as-pickable`,
  showNewAsPackable: `${SETTING_CNAME_BASE}defaults__order-new-as-packable`,
  scanSerialAsPackable: `${SETTING_CNAME_BASE}defaults__scan-serial-as-packable`,
  orderTagFilters: `${SETTING_CNAME_BASE}__order-tag-filters`,

  packFilterCatalogues: `${SETTING_CNAME_BASE}pack-filters__catalogues`,
  packFilterTags: `${SETTING_CNAME_BASE}pack-filters__tags`,

  supplierCatalogueLastViewedTimestamps: `${SETTING_CNAME_BASE}sc__last-viewed`
}

export const DEFAULT_TAB_OPTIONS = [
  { label: 'Overview', value: 'overview', route: 'Order/Overview' },
  { label: 'Pick', value: 'pick', route: 'Order/Pick' },
  { label: 'Pack', value: 'pack', route: 'Order/Pack' }
]
export const ORDER_STAGE_OPTIONS = [
  { label: 'Order is Fulfilled', value: 'fulfilled' },
  { label: 'Order is Picked', value: 'picked' },
  { label: 'Order is Created', value: 'created' }
]

export const PRICING_SERVICES = [
  { label: 'SysCalc', value: PricingApi.syscalc, private: false },
]

export const PRICING_SERVICES_ACCOUNT_CONFIG = {
  'syscalc': [
    {
      section: 'firstmile', label: 'Firstmile',
      fields: [
      { field: 'firstMile.code', label: 'Code', type: 'text' },
        { field: 'firstMile.cost', label: 'Cost', type: 'text' }
      ],
    },
    {
      section: 'middlemile', label: 'Middlemile',
      fields: [
        { field: 'middleMile.code', label: 'Code', type: 'text' },
        { field: 'middleMile.cost', label: 'Cost', type: 'text' }
      ],
    }
  ],
}

import IconDpd from '@/assets/icons/icon-dpd.png'
import IconPostnl from '@/assets/icons/icon-postnl.png'
import IconCbHub from '@/assets/icons/icon-cbhub.png'
import IconSinerlog from '@/assets/icons/icon-sinerlog.png'
import IconVDH from '@/assets/icons/icon-vdh.png'
import IconDirect from '@/assets/icons/icon-direct.png'
// import IconBudbee from '@/assets/icons/icon-budbee.png'
import IconDHL from '@/assets/icons/icon-dhl.png'
import IconGLS from '@/assets/icons/icon-gls.png'
import IconMileExpress from '@/assets/icons/icon-mileexpress.png'
import IconTrunkrs from '@/assets/icons/icon-trunkrs.png'

// @ TEMP DEFAULTS
// 'dhl', 'deutschepost',
export const SHIPPING_CARRIERS = [
  { label: 'DPD', value: ShipmentApi.dpd, icon: IconDpd, types: ['default', 'validate'] },
  { label: 'PostNL', value: ShipmentApi.postnl, icon: IconPostnl, types: ['default'] },
  { label: 'DHL', value: ShipmentApi.dhl, icon: IconDHL, types: ['default'] },
  { label: 'GLS', value: ShipmentApi.gls, icon: IconGLS, types: ['default'] },
  { label: 'Sinerlog', value: ShipmentApi.sinerlog, icon: IconSinerlog, types: ['warehouse'], private: true },
  { label: 'MileExpress', value: ShipmentApi.mileexpress, icon: IconMileExpress, types: ['default'], private: true },
  { label: 'Van der Helm', value: ShipmentApi.vdh, icon: IconVDH, types: ['default'], private: true },
  { label: 'CBHub', value: ShipmentApi.cbhub, icon: IconCbHub, types: ['default'], private: true },
  { label: 'Trunkrs', value: ShipmentApi.trunkrs, icon: IconTrunkrs, types: ['default'] },
  { label: 'Direct', value: ShipmentApi.simpleshipment, icon: IconDirect, types: ['default'] }
]

export const SHIPMENT_CARRIER_DICT = Object.fromEntries(SHIPPING_CARRIERS.map(s => [s.value, s]))

export const SHIPPING_CARRIER_ACCOUNT_CONFIGS = {
  'postnl': {
    // validate: {
    //   type: 'validate'
    // },
    default: {
      type: 'shipment',
      sender: {
        name: '',
        address: {
          street: '',
          street_number: '',
          city: '',
          zipcode: '',
          country_iso: ''
        },
        contact: {
          name: ''
        },
        meta: {
          validation_enabled: false,
          letterBox_enabled: false,
          collection_location: '',
          customer_code: '',
          customer_number: ''
        }
      }
    }
  },
  'dhl': {
    default: {
      type: 'shipment',
      sender: {
        address: {
          street: '',
          street_number: '',
          addition: '',
          city: '',
          zipcode: '',
          country_iso: '',
        },
        contact: {
          first_name: '',
          last_name: '',
          company_name: '',
          additional_name: ''
        },
        meta: {
          validation_enabled: false,
          letterBox_enabled: false,
          account_id: '',
        }
      }
    }
  },
  'dpd': { default: { type: 'shipment' } },
  'gls': { default: { type: 'shipment' } },
  'packs': { default: { type: 'shipment' } },
  'budbee': { default: { type: 'shipment' } },
  'cbhub': { default: { type: 'shipment' } },
  'vdh': { default: { type: 'shipment' } },
  'royalmail': { default: { type: 'shipment' } },
  'sinerlog': {
    default: { type: 'shipment' },
    warehouse: { type: 'warehouse' }
  },
  'simpleshipment': { default: { type: 'shipment' } },
  'mileexpress': { default: { type: 'shipment' } },
  'trunkrs': { default: { type: 'shipment' } }
}
export const SHIPPING_CARRIER_CONFIGS = {
  // { id:'dhl', value: ShipmentApi.dpd },
  // { id:'budbee', value: ShipmentApi.dpd },
  // { id:'packs', value: ShipmentApi.dpd },
  // { id:'rjp', value: ShipmentApi.dpd },
  dpd: [
    { field: 'customerId', type: 'text' },
    { field: 'depot', type: 'text' }
  ],
  gls: [
    // {
    //   section: 'settings', label: '',
    //   fields: [
    //     { field: 'sender.meta.validation_enabled', label: 'Address validation', type: 'checkbox' },
    //     { field: 'sender.meta.letterBox_enabled', label: 'Letterbox', type: 'checkbox' }
    //   ]
    // },
    {
      section: 'address', label: 'Address',
      fields: [
        { field: 'sender.address.street', label: 'Street', type: 'text' },
        { field: 'sender.address.street_number', label: 'Street number', type: 'text' },
        { field: 'sender.address.addition', label: 'Addition', type: 'text' },
        { field: 'sender.address.city', label: 'City', type: 'text' },
        { field: 'sender.address.zipcode', label: 'Zipcode', type: 'text' },
        { field: 'sender.address.country_iso', label: 'Country', type: 'text' },
      ]
    },
    {
      section: 'contact', label: '',
      fields: [
        { field: 'sender.contact.first_name', label: 'First name', type: 'text' },
        { field: 'sender.contact.last_name', label: 'Last name', type: 'text' },
        { field: 'sender.contact.company_name', label: 'Company name', type: 'text' },
        { field: 'sender.contact.additional_name', label: 'Company name addition', type: 'text' },
      ]
    },
    {
      section: 'customer_meta', label: '',
      fields: [
        { field: 'sender.meta.subscription_key', label: 'Primary Key', type: 'text' },
      ]
    },
  ],
  dhl: [
    {
      section: 'API Type', label: '',
      fields: [
        { field: 'type', type: 'select', label: 'API  Type', options: ['Parcel Benelux', 'Parcel DE'] }
      ]
    },
    {
      section: 'settings', label: '',
      fields: [
        { field: 'sender.meta.validation_enabled', label: 'Address validation', type: 'checkbox' },
        { field: 'sender.meta.letterBox_enabled', label: 'Letterbox', type: 'checkbox' }
      ]
    },
    {
      section: 'address', label: 'Address',
      fields: [
        { field: 'sender.address.street', label: 'Street', type: 'text' },
        { field: 'sender.address.street_number', label: 'Street number', type: 'text' },
        { field: 'sender.address.addition', label: 'Addition', type: 'text' },
        { field: 'sender.address.city', label: 'City', type: 'text' },
        { field: 'sender.address.zipcode', label: 'Zipcode', type: 'text' },
        { field: 'sender.address.country_iso', label: 'Country', type: 'text' },
      ]
    },
    {
      section: 'contact', label: '',
      fields: [
        { field: 'sender.contact.first_name', label: 'First name', type: 'text' },
        { field: 'sender.contact.last_name', label: 'Last name', type: 'text' },
        { field: 'sender.contact.company_name', label: 'Company name', type: 'text' },
        { field: 'sender.contact.additional_name', label: 'Company name addition', type: 'text' },
      ]
    },
    {
      section: 'customer_meta', label: '',
      fields: [
        { field: 'sender.meta.account_id', label: 'Account id', type: 'text' },
      ]
    },
  ],
  postnl: [
    // {
    //   section: 'apikey', label: 'API Key',
    //   fields: [
    //     { field: 'token', type: 'password' }
    //   ]
    // },
    {
      section: 'settings', label: '',
      fields: [
        { field: 'sender.meta.validation_enabled', label: 'Address validation', type: 'checkbox' },
        { field: 'sender.meta.letterBox_enabled', label: 'Letterbox', type: 'checkbox' }
      ]
    },
    {
      section: 'address', label: 'Address',
      fields: [
        { field: 'sender.address.street', label: 'Street', type: 'text' },
        { field: 'sender.address.street_number', label: 'Street number', type: 'text' },
        { field: 'sender.address.city', label: 'City', type: 'text' },
        { field: 'sender.address.zipcode', label: 'Zipcode', type: 'text' },
        { field: 'sender.address.country_iso', label: 'Country', type: 'text' },
      ]
    },
    {
      section: 'contact', label: '',
      fields: [
        { field: 'sender.contact.company_name', label: 'Company name', type: 'text' },
        { field: 'sender.contact.name', label: 'Contact name', type: 'text' },
        { field: 'sender.contact.email', label: 'Contact email', type: 'text' },
      ]
    },
    {
      section: 'customer_meta', label: '',
      fields: [
        { field: 'sender.meta.customer_code', label: 'Customer code', type: 'text' },
        { field: 'sender.meta.customer_number', label: 'Customer number', type: 'text' },
        { field: 'sender.meta.collection_location', label: 'Collection location', type: 'text' }
      ]
    },
  ],
  sinerlog: [{
    section: 'options', label: 'Options',
    fields: [
      { field: 'sender.deliveryType', label: 'Delivery type', type: 'text' }
    ]
  },
  {
    section: 'sender.shippingSellerAddress', label: 'Seller Address',
    fields: [
      { field: 'sender.shippingSellerAddress.address', label: 'Street', type: 'text' },
      // { field: 'sender.shippingSellerAddress.street', label: 'street', type: 'text' },
      { field: 'sender.shippingSellerAddress.number', label: 'Street number', type: 'text' },
      { field: 'sender.shippingSellerAddress.neighboord', label: 'Neighborhood', type: 'text' },
      { field: 'sender.shippingSellerAddress.zipcode', label: 'Zipcode', type: 'text' },
      { field: 'sender.shippingSellerAddress.city', label: 'City', type: 'text' },
      { field: 'sender.shippingSellerAddress.countryCode', label: 'Country ISO', type: 'text' },
      { field: 'sender.shippingSellerAddress.state', label: 'State', type: 'text' },
      { field: 'sender.shippingSellerAddress.name', label: 'Contact name', type: 'text' },
      { field: 'sender.shippingSellerAddress.phone', label: 'Contact Phone', type: 'text' },
      { field: 'sender.shippingSellerAddress.email', label: 'Contact Email', type: 'text' },
      { field: 'sender.shippingSellerAddress.document', label: 'Document (passport)', type: 'text' },
    ]
  },
  {
    section: 'sender.airport', label: 'Airport information',
    fields: [
      { field: 'sender.airport.airline', label: 'Airline', type: 'text' },
      { field: 'sender.airport.origin', label: 'Origin', type: 'text' },
      { field: 'sender.airport.destination', label: 'Destination', type: 'text' }
    ]
  }
  ],
  vdh: [{
    section: 'settings', label: 'Settings',
    fields: [
      { field: 'sender.street', label: 'Street', type: 'text' },
      { field: 'sender.street_number', label: 'Street Number', type: 'text' },
      { field: 'sender.addition', label: 'Addition', type: 'text' },
      { field: 'sender.city', label: 'City', type: 'text' },
      { field: 'sender.country_iso', label: 'Country ISO', type: 'text' },
      { field: 'sender.email', label: 'Email', type: 'text' },
      { field: 'sender.phone', label: 'Phone', type: 'text' }
    ]
  }],
  cbhub: [{
    section: 'settings', label: 'Settings',
    fields: [
      { field: 'sender.street', label: 'Street', type: 'text' },
      { field: 'sender.street_number', label: 'Street Number', type: 'text' },
      { field: 'sender.addition', label: 'Addition', type: 'text' },
      { field: 'sender.city', label: 'City', type: 'text' },
      { field: 'sender.country_iso', label: 'Country ISO', type: 'text' },
      { field: 'sender.email', label: 'Email', type: 'text' },
      { field: 'sender.phone', label: 'Phone', type: 'text' }
    ]
  }],
  mileexpress: [
    {
      section: 'address', label: 'Address',
      fields: [
        { field: 'address.address', label: 'Street', type: 'text' },
        { field: 'address.number', label: 'Street number', type: 'number' },
        { field: 'address.additional_info', label: 'Addition', type: 'text' },
        { field: 'address.city.name', label: 'City', type: 'text' },
        { field: 'address.neighborhood', label: 'Neighborhood', type: 'text' },
        { field: 'address.zip_code', label: 'Zipcode', type: 'text' },
        { field: 'address.city.uf', label: 'State code', type: 'text' },
        { field: 'address.country_code', label: 'Country numeric code', type: 'text' },
        { field: 'address.document_id', label: 'Document (passport)', type: 'text' },
      ]
    },
    {
      section: 'contact', label: 'Contact information',
      fields: [
        { field: 'name', label: 'Name', type: 'text' },
        { field: 'email', label: 'Email', type: 'text' },
        { field: 'company_id', label: 'Company ID', type: 'text' },
        { field: 'shipper_id', label: 'Shipper ID', type: 'text' }
      ]
    },
    {
      section: 'airport', label: 'Airport information',
      fields: [
        { field: 'airport.airline', label: 'Airline', type: 'text' },
        { field: 'airport.origin', label: 'Origin', type: 'text' },
        { field: 'airport.destination', label: 'Destination', type: 'text' }
      ]
    }],
  trunkrs: [
    {
      section: 'information', label: 'Information',
      fields: [
        { field: 'sender.name', label: 'Name', type: 'text'},
        { field: 'sender.companyName', label: 'Company Name', type: 'text'},
        { field: 'sender.emailAddress', label: 'Email Address', type: 'text'},
        { field: 'sender.phoneNumber', label: 'Phone Number', type: 'text'},
        { field: 'sender.address', label: 'Street and number', type: 'text'},
        { field: 'sender.postalCode', label: 'Postal Code', type: 'text'},
        { field: 'sender.city', label: 'City', type: 'text'},
        { field: 'sender.country', label: 'Country ISO', type: 'text'},
        { field: 'sender.additionalRemarks', label: 'Additional Remarks', type: 'text'}
      ]
    }
  ]
}

export const SKU_CAT_PAD_LENGTH = 3
export const SKU_ID_PAD_LENGTH = 5
export const SKU_PAD_CHAR = '0'

// @ DATE
export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ'
export const DATE_DISPLAY_FORMAT_HOURS = 'DD-MM-YYYY HH:mm'
export const DATE_DISPLAY_FORMAT = 'DD-MM-YYYY'
export const DATE_DISPLAY_FORMAT_SHORT = 'Do MMM'
export const DATE_DISPLAY_FORMAT_SHORT_HOURS = 'Do MMM HH:mm'

export const DEFAULT_STATUS_COLOR = '#808387'
export const NEUTRAL_STATUS_COLOR = '#4b79f0'
// export const POSITIVE_STATUS_COLOR = '#71d0b7'
export const POSITIVE_STATUS_COLOR = '#12CDA4'
// const WARNING_STATUS_COLOR = '#f8cd75'
export const WARNING_STATUS_COLOR = '#edb547'
export const NEGATIVE_STATUS_COLOR = '#f88175'

export enum ItemViewMode {
  Default = 2,
  List = 1,
  Wide = 3
}

export const ItemViewModeDict = Object.fromEntries(Object.keys(ItemViewMode).map(k => ([k, ItemViewMode[k]])))

export interface StatusDefinition {
  id: Status,
  value: any,
  label: string,
  alias?: Array<string>,
  altLabel?: string,
  customLabel?: string,
  sourceLabel?: string,
  color?: string,
  combinable?: boolean
}

// @ STATUS
export const STATUS_NEW: StatusDefinition = {
  id: Status.New,
  alias: [],
  value: 'new',
  label: 'New',
  altLabel: 'New',
  color: NEUTRAL_STATUS_COLOR
}
export const STATUS_UNKNOWN: StatusDefinition = {
  id: Status.Unknown,
  alias: [],
  value: 'unknown',
  label: 'Unknown',
  altLabel: 'Unknown',
  color: DEFAULT_STATUS_COLOR
}
export const STATUS_PENDING: StatusDefinition = {
  id: Status.Pending,
  alias: [],
  value: 'pending',
  label: 'Pending',
  altLabel: 'Not started',
  customLabel: 'Not started',
  color: DEFAULT_STATUS_COLOR
}
export const STATUS_QUEUED: StatusDefinition = {
  id: Status.Queued,
  alias: [],
  value: 'queued',
  label: 'Queued',
  altLabel: 'In queue',
  customLabel: 'Ready to Pick',
  sourceLabel: 'Waiting', // NOTE accepting that different content-types need different status labels... we'll want a nicer sollution than this (i.e relate the labels to the content-type)
  color: NEUTRAL_STATUS_COLOR
}

export const STATUS_STARTING: StatusDefinition = {
  id: Status.Starting,
  alias: [],
  value: 'starting',
  label: 'Starting',
  altLabel: 'Initializing',
  customLabel: 'Picking',
  sourceLabel: 'Starting Processing',
  color: NEUTRAL_STATUS_COLOR
}
export const STATUS_STARTED: StatusDefinition = {
  id: Status.Started,
  alias: ['accepted', 'created'],
  value: 'started',
  label: 'Started',
  altLabel: 'Up',
  customLabel: 'Picked',
  sourceLabel: 'Processing',
  color: NEUTRAL_STATUS_COLOR
}
export const STATUS_ACTIVE: StatusDefinition = {
  id: Status.Active,
  alias: ['online'],
  value: 'active',
  label: 'Running',
  altLabel: 'Online',
  customLabel: 'Packing',
  sourceLabel: 'Delivering',
  color: NEUTRAL_STATUS_COLOR
}

// in-between state before "updated"
export const STATUS_CHANGED: StatusDefinition = {
  id: Status.Changed,
  alias: ['draft'],
  value: 'changed',
  label: 'Changed',
  altLabel: 'Edited',
  customLabel: 'Changed',
  combinable: true,
  color: WARNING_STATUS_COLOR
}
export const STATUS_UPDATED: StatusDefinition = {
  id: Status.Updated,
  alias: [],
  value: 'updated',
  label: 'Updated',
  altLabel: 'Renewed',
  customLabel: 'Updated',
  combinable: true,
  color: WARNING_STATUS_COLOR
}

export const STATUS_RESOLVED: StatusDefinition = {
  id: Status.Resolved,
  alias: [],
  value: 'resolved',
  label: 'Resolved',
  altLabel: 'Fulfilled',
  customLabel: 'Packed',
  sourceLabel: 'Ready for Transport',
  color: POSITIVE_STATUS_COLOR
}
export const STATUS_TRANSITING: StatusDefinition = {
  id: Status.Transiting,
  alias: [],
  value: 'transiting',
  label: 'In Transit',
  altLabel: 'In Transit',
  customLabel: 'In Transit',
  sourceLabel: 'In Transit',
  color: POSITIVE_STATUS_COLOR
}
export const STATUS_READY: StatusDefinition = {
  id: Status.Ready,
  alias: [],
  value: 'ready',
  label: 'Ready for Pickup',
  altLabel: 'Ready for Pickup',
  customLabel: 'Ready',
  sourceLabel: 'Ready for Storage',
  color: POSITIVE_STATUS_COLOR
}
export const STATUS_FINAL: StatusDefinition = {
  id: Status.Final,
  alias: [],
  value: 'final',
  label: 'Finalized',
  altLabel: 'Final',
  sourceLabel: 'Delivered',
  customLabel: 'Delivered',
  // sourceLabel: 'Finished',
  color: POSITIVE_STATUS_COLOR
}

export const STATUS_CANCELLED: StatusDefinition = {
  id: Status.Cancelled,
  alias: [],
  value: 'cancelled',
  label: 'Cancelled',
  altLabel: 'Cancel',
  customLabel: 'Cancelled',
  color: DEFAULT_STATUS_COLOR
}
export const STATUS_FAILED: StatusDefinition = {
  id: Status.Failed,
  alias: ['error', 'crashed'],
  value: 'failed',
  label: 'Failed',
  altLabel: 'Error',
  customLabel: 'Has Issue',
  sourceLabel: 'Has Issue',
  combinable: true,
  color: NEGATIVE_STATUS_COLOR
}
export const STATUS_STOPPED: StatusDefinition = {
  id: Status.Stopped,
  alias: ['offline'],
  value: 'stopped',
  label: 'Stopped',
  altLabel: 'Offline',
  customLabel: 'Stopped',
  combinable: true,
  color: DEFAULT_STATUS_COLOR
}
export const STATUS_PAUSED: StatusDefinition = {
  id: Status.Paused,
  alias: [],
  value: 'paused',
  label: 'On Hold',
  altLabel: 'Paused',
  combinable: true,
  color: DEFAULT_STATUS_COLOR
}
export const STATUS_DELETED: StatusDefinition = {
  id: Status.Deleted,
  alias: [],
  value: 'deleted',
  label: 'Deleted',
  altLabel: 'Removed',
  customLabel: 'Deleted',
  color: DEFAULT_STATUS_COLOR
}

export const STATUS_UNSOURCED: StatusDefinition = {
  id: Status.Unsourced,
  alias: ['not-loaded'],
  value: 'unsourced',
  label: 'Unsourced',
  altLabel: 'Not Loaded',
  customLabel: 'Unsourced',
  color: DEFAULT_STATUS_COLOR
}
export const STATUS_SOURCING: StatusDefinition = {
  id: Status.Sourcing,
  alias: ['loading'],
  value: 'sourcing',
  label: 'Sourcing',
  altLabel: 'Loading',
  customLabel: 'Sourcing',
  color: NEUTRAL_STATUS_COLOR
}
export const STATUS_SOURCED: StatusDefinition = {
  id: Status.Sourced,
  alias: ['loaded'],
  value: 'sourced',
  label: 'Sourced',
  altLabel: 'Loaded',
  customLabel: 'Sourced',
  color: POSITIVE_STATUS_COLOR
}

export const STATUS_REPLACED: StatusDefinition = {
  id: Status.Replaced,
  alias: ['replaced'],
  value: 'replaced',
  label: 'Replaced',
  altLabel: 'Replaced',
  customLabel: 'Replaced',
  combinable: false,
  color: WARNING_STATUS_COLOR
}
export const STATUS_ARCHIVED: StatusDefinition = {
  id: Status.Archived,
  alias: ['deprecated'],
  value: 'archived',
  label: 'Archived',
  altLabel: 'Archived',
  customLabel: 'Archived',
  combinable: true,
  color: DEFAULT_STATUS_COLOR
}

// matches every export above
const STATES = [
  STATUS_NEW,
  STATUS_UNKNOWN,
  STATUS_PENDING,
  STATUS_QUEUED,
  STATUS_STARTING,
  STATUS_STARTED,
  STATUS_ACTIVE,
  STATUS_CHANGED,
  STATUS_UPDATED,
  STATUS_TRANSITING,
  STATUS_READY,
  STATUS_RESOLVED,
  STATUS_FINAL,
  STATUS_CANCELLED,
  STATUS_FAILED,
  STATUS_STOPPED,
  STATUS_PAUSED,
  STATUS_DELETED,
  STATUS_UNSOURCED,
  STATUS_SOURCING,
  STATUS_SOURCED,
  STATUS_ARCHIVED,
  STATUS_REPLACED
]

// NOTE this can  be retrieved using STATUS.get
export const DISPLAY_STATUS = Object.fromEntries(
  STATES
    .map(s => ([
      [s.id, s],
      ...(s.alias || []).map(a => ([a, s]))
    ])).flat(1)
)

//   [STATUS_NEW.id]: STATUS_NEW,
//   [STATUS_PENDING.id]: STATUS_PENDING,
//   [STATUS_QUEUED.id]: STATUS_QUEUED,
//   [STATUS_STARTING.id]: STATUS_STARTING,
//   [STATUS_STARTED.id]: STATUS_STARTED,
//   [STATUS_ACTIVE.id]: STATUS_ACTIVE,
//   [STATUS_UPDATED.id]: STATUS_UPDATED,
//   [STATUS_RESOLVED.id]: STATUS_RESOLVED,
//   [STATUS_FINAL.id]: STATUS_FINAL,
//   [STATUS_CHANGED.id]: STATUS_CHANGED,
//   [STATUS_CANCELLED.id]: STATUS_CANCELLED,
//   [STATUS_FAILED.id]: STATUS_FAILED,
//   [STATUS_STOPPED.id]: STATUS_STOPPED,
//   [STATUS_PAUSED.id]: STATUS_PAUSED,
//   [STATUS_DELETED.id]: STATUS_DELETED,
//   [STATUS_UNSOURCED.id]: STATUS_UNSOURCED,
//   [STATUS_SOURCING.id]: STATUS_SOURCING,
//   [STATUS_SOURCED.id]: STATUS_SOURCED,
//   [STATUS_ARCHIVED.id]: STATUS_ARCHIVED
// }

export const STATUS = {
  get (s: Status): StatusDefinition { return DISPLAY_STATUS[s] },
  all: () => Object.keys(STATUS).filter(f => !['get', 'all'].includes(f)).map(s => STATUS[s]),
  get NEW (): Status {
    return STATUS_NEW.id
  },
  get UNKNOWN (): Status {
    return STATUS_UNKNOWN.id
  },
  get PENDING (): Status {
    return STATUS_PENDING.id
  },
  get QUEUED (): Status {
    return STATUS_QUEUED.id
  },
  get STARTING (): Status {
    return STATUS_STARTING.id
  },
  get STARTED (): Status {
    return STATUS_STARTED.id
  },
  get ACTIVE (): Status {
    return STATUS_ACTIVE.id
  },
  get UPDATED (): Status {
    return STATUS_UPDATED.id
  },
  get RESOLVED (): Status {
    return STATUS_RESOLVED.id
  },
  get TRANSITING (): Status {
    return STATUS_TRANSITING.id
  },
  get READY (): Status {
    return STATUS_READY.id
  },
  get FINAL (): Status {
    return STATUS_FINAL.id
  },
  get CHANGED (): Status {
    return STATUS_CHANGED.id
  },
  get CANCELLED (): Status {
    return STATUS_CANCELLED.id
  },
  get FAILED (): Status {
    return STATUS_FAILED.id
  },
  get STOPPED (): Status {
    return STATUS_STOPPED.id
  },
  get PAUSED (): Status {
    return STATUS_PAUSED.id
  },
  get DELETED (): Status {
    return STATUS_DELETED.id
  },
  get UNSOURCED (): Status {
    return STATUS_UNSOURCED.id
  },
  get SOURCING (): Status {
    return STATUS_SOURCING.id
  },
  get SOURCED (): Status {
    return STATUS_SOURCED.id
  },
  get ARCHIVED (): Status {
    return STATUS_ARCHIVED.id
  },
  get REPLACED (): Status {
    return STATUS_REPLACED.id
  }
}

export const DEFAULT_STOCK_ITEM_MAP = {
  id: ''
}

export const DEFAULT_ORDER_MAP = {
  id: '',
  reference: '',
  price: '',
  fullname: '',
  firstname: '',
  lastname: '',
  catalogue: '',
  notes: '',
  tags: '',
  meta: '',
  'shipping_address.email': '',
  'shipping_address.phone': '',
  'shipping_address.region': '',
  'shipping_address.company': '',
  'shipping_address.country': '',
  'shipping_address.city': '',
  'shipping_address.zipcode': '',
  'shipping_address.street': '',
  'shipping_address.street_number': '',
  'shipping_address.addition': '',
  'shipping_address.fullname': '',
  'shipping_address.firstname': '',
  'shipping_address.lastname': '',
  'shipping_address.country-iso': '',
  'billing_address.email': '',
  'billing_address.phone': '',
  'billing_address.region': '',
  'billing_address.company': '',
  'billing_address.country': '',
  'billing_address.city': '',
  'billing_address.zip': '',
  'billing_address.address': '',
  'billing_address.street': '',
  'billing_address.street_number': '',
  'billing_address.addition': '',
  'billing_address.fullname': '',
  'billing_address.firstname': '',
  'billing_address.lastname': '',
  'billing_address.country-iso': '',
  'products[].ean': '',
  'products[].sku': '',
  'products[].title': '',
  'products[].quantity': '',
  'products[].weight': '',
  'products[].price': '',
  'products[].vat': '',
  'products[].carrier': '',
  'products[].vendor.sku': '',
  'products[].vendor.title': ''
}

export const DEFAULT_MAPS = {
  order: DEFAULT_ORDER_MAP,
  stockItem: DEFAULT_STOCK_ITEM_MAP,
  stock: DEFAULT_STOCK_ITEM_MAP,
  stock_item: DEFAULT_STOCK_ITEM_MAP
}

export const DEFAULT_ORDER_MAP_FIELD_ORDER = {
  id: 1,
  reference: 2,
  price: 3,
  fullname: 4,
  firstname: 5,
  lastname: 6,
  catalogue: 7,
  email: 8,
  phone: 9,
  region: 10,
  company: 11,
  country: 12,
  city: 13,
  zipcode: 14,
  street: 15,
  streetnumber: 16,
  'address-addition': 17,
  'shipping-fullname': 18,
  'shipping-firstname': 19,
  'shipping-lastname': 20,
  'country-iso': 21,
  'billing-email': 22,
  'billing-phone': 23,
  'billing-region': 24,
  'billing-company': 25,
  'billing-country': 26,
  'billing-city': 27,
  'billing-zip': 28,
  'billing-address': 29,
  'billing-street': 30,
  'billing-street-number': 31,
  'billing-addition': 32,
  'billing-fullname': 33,
  'billing-firstname': 34,
  'billing-lastname': 35,
  'billing-country-iso': 36,
  notes: 37,
  tags: 38,
  'lineitem-sku': 39,
  'lineitem-vat': 40,
  'lineitem-price': 41,
  'lineitem-name': 42,
  'lineitem-weight': 43,
  'shipping-carrier': 44,
  'Lineitem-quantity': 45,
  'shipping-vat': 46
}
